export const updateBlueprintAnswerAction = (
  workorderId,
  updatedAnswer
) => dispatch =>
    dispatch({
      type: UPDATE_BLUEPRINT_ANSWER.ACTION,
      payload: { workorderId, updatedAnswer },
    })

export const UPDATE_BLUEPRINT_ANSWER = {
  ACTION: 'UPDATE_BLUEPRINT_ANSWER',

  call: ({ state, workorderId, updatedAnswer }) => {
    return {
      ...state,
      items: state.items.map(workorder => {
        if (workorder.id !== workorderId) return workorder

        return {
          ...workorder,
          synced: false,
          blueprint_answers: workorder.blueprint_answers.map(blueprint_answer => blueprint_answer.id == updatedAnswer.id
            ? { ...updatedAnswer }
            : blueprint_answer
          ),
        }
      }),
    }
  }
}
